<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <img :src="require('@/assets/img/left_arrow.png')" alt="" @click="goBack" />
      <span class="main-title">续费订单</span>
    </h2>
    <div class="list-content">
      <el-card>
        <renewalOrderTable
          :page-no="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          :data="data"
          :total="total"
          @handle-pageNo="handlePageNo"
          @handle-pageSize="handlePageSize"
          @handle-viewOrderDetail="handleViewOrderDetail"
        />
      </el-card>
    </div>
    <el-drawer
      title="订单详情"
      customClass="order-detail-drawer"
      :visible.sync="orderDetailDrawer"
      direction="rtl"
      size="63%"
      :showClose="false"
    >
      <renewalOrderDetail :id="nowId" :key="nowId" />
    </el-drawer>
  </div>
</template>

<script>
import Fetch from '@/api';
import renewalOrderDetail from './components/renewalOrderDetail.vue';
import renewalOrderTable from './components/renewalOrderTable.vue';
export default {
  name: 'renewalOrderList',
  components: {
    renewalOrderDetail,
    renewalOrderTable
  },
  data() {
    return {
      searchParams: {
        pageNo: 1,
        pageSize: 10
      },
      data: [],
      total: 1,
      orderDetailDrawer: false,
      nowId: ''
    };
  },
  created() {
    this.getRenewalOrderList();
  },
  methods: {
    async getRenewalOrderList() {
      const {
        searchParams: { pageNo, pageSize }
      } = this;
      const params = {
        pageNo,
        pageSize
      };
      const res = await Fetch.getRenewalOrderList(params);
      this.data = res.data;
      this.total = res.totalCount;
    },
    handleViewOrderDetail(id) {
      this.nowId = id;
      this.orderDetailDrawer = true;
    },
    handlePageNo(pageNo) {
      this.searchParams.pageNo = pageNo;
      return this.getRenewalOrderList();
    },
    handlePageSize(pageSize) {
      this.searchParams.pageSize = pageSize;
      return this.getRenewalOrderList();
    },
    goBack() {
      history.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.title-area {
  img {
    margin-right: 2px;
    height: 18px;
    width: 18px;
    cursor: pointer;
  }
}
/deep/.order-detail-drawer {
  overflow: auto;
  .el-drawer__header {
    padding: 24px;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #262626;
    line-height: 24px;
  }
}
</style>
